import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import {
	DELETION_SUCCESS,
	DELETION_FAILURE,
	CANCEL,
	SHOW_DIALOG,
	type Action,
} from '../../state/actions.tsx';
import {
	getSuccessCallback,
	getErrorCallback,
	getCancelCallback,
	getModalShownCallback,
	getTargetVersionForFixVersionField,
} from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

export const cancelEpic = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action$: ActionsObservable<any>,
	store: MiddlewareAPI<State>, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any /* Observable<void> */ =>
	action$.ofType(CANCEL).mergeMap(() => {
		getCancelCallback(store.getState())();

		return Observable.empty<never>();
	});

export const successEpic = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any /* Observable<void> */ =>
	action$.ofType(DELETION_SUCCESS).mergeMap(() => {
		const state = store.getState();
		getSuccessCallback(state)({
			movedRelatedIssuesTo: getTargetVersionForFixVersionField(state),
		});

		return Observable.empty<never>();
	});

export const modalShownEpic = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any /* Observable<void> */ =>
	action$.ofType(SHOW_DIALOG).mergeMap(() => {
		const state = store.getState();
		getModalShownCallback(state)();

		return Observable.empty<never>();
	});

export const errorEpic = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any /* Observable<void> */ =>
	action$.ofType(DELETION_FAILURE).mergeMap((action) => {
		getErrorCallback(store.getState())(action.payload);

		return Observable.empty<never>();
	});
